"use strict";
export function initInScope($scope) {
    if ($('.js-img-copyright').length) {
        let copyrightItem = $scope.find('.js-img-copyright');
        copyrightItem.on('click', function (evt) {
            evt.stopImmediatePropagation();
            evt.preventDefault();
            $(this).toggleClass('active');
        });
    }
}